<script setup>
import { useMenuStore } from "@/stores/menu";
import { useSettingsStore } from "@/stores/settings";
import { useAuthStore } from "@stores/auth.js";

const settingsStore = useSettingsStore();
const authStore = useAuthStore();
const menuStore = useMenuStore();

const settings = settingsStore.settings;

const close = () => {
  menuStore.targe();
  menuStore.closeTopAd();
};

onMounted(() => {
  if (settings.refer_enabled) {
    menuStore.topAd = true;
  }

});
</script>

<template>
  <div
    v-if="menuStore.targeOpened && settings.refer_enabled && menuStore.topAd && authStore.isLoggedIn"
    class="relative flex h-[50px] w-full items-center justify-normal gap-3 bg-brand-topbar px-4 py-2 font-sans sm:h-10 md:justify-center"
  >
    <div class="flex items-center gap-3 sm:ml-auto">
      <p class="text-xss font-medium text-brand-topbar-text lg:text-center lg:text-base">
        Indique um amigo e ganhe
        {{ money(settings.refer_referrer_amount / 100) }} de {{ settings.refer_referrer_wallet_type === 3 ? 'SALDO' : 'CASHBACK' }} para cada amigo que
        convidar💥
      </p>
      <NuxtLink to="/user/indications">
        <button
          class="rounded-md bg-brand-topbar-action px-2 py-1 text-sm font-medium text-brand-topbar-action-text"
        >
          Resgatar
        </button>
      </NuxtLink>
    </div>

    <button class="ml-auto" @click="close">
      <Icon name="ion:close" class="h-6 w-6 text-bzMenuTextLight" />
    </button>
  </div>
</template>
